module.exports = __webpack_public_path__ + "3fb931f870087fe7a680ac41550334c2.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/li1-91.png
// module id = 612
// module chunks = 0